import React, { useState, useEffect } from "react";
import {
    BrowserRouter as Router, Link,
    useLocation
} from "react-router-dom";
import faqData from "../data/FaqData.json";
import SearchInput from "./SearchInput";
import "./FAQAccordian.css";


function FAQAccordion() {
    const [searchResults, setSearchResults] = useState([...faqData]);
    const itemsPerPage = 5;
    const [currentPage, setCurrentPage] = useState(1);
    const [currentItems, setCurrentItems] = useState([]);
    const [activeIndex, setActiveIndex] = useState(null);
    const [arrowActive, setArrowActive] = useState(false);

    useEffect(() => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        setCurrentItems(searchResults.slice(startIndex, endIndex));
    }, [searchResults, currentPage, itemsPerPage]);

    const totalPages = Math.ceil(searchResults.length / itemsPerPage);

    const toggleAccordion = (index) => {
        if (activeIndex === index) {
            setActiveIndex(null);
            setArrowActive(false);
        } else {
            setActiveIndex(index);
            setArrowActive(true);
        }
    };

    const location = useLocation();
    const propsData =
        location.state && typeof location.state.tabID === "string"
            ? location.state.tabID
            : "GeneralFAQ";
    const [displaySkill, setDisplaySkill] = useState(propsData);

    const renderFAQs = (category) => {
        return currentItems.map((item, itemIndex) => (
            item[category].map((faq, faqIndex) => (
                <div key={`${itemIndex}-${faqIndex}`} className="faq-item">
                    <div
                        className="question"
                        onClick={() => toggleAccordion(faqIndex)}
                        style={{ cursor: "pointer" }}
                    >
                        <p className="faq-que">
                            {faq.id}. {faq.question}
                        </p>
                        {arrowActive && activeIndex === faqIndex ? (
                            <img
                                src="images/FAQ/Up-arrow.png"
                                className="arrowIcon"
                                alt="Up Arrow"
                            />
                        ) : (
                            <img
                                src="images/FAQ/Down-arrow.png"
                                className="arrowIcon"
                                alt="Down Arrow"
                            />
                        )}
                    </div>
                    {activeIndex === faqIndex && (
                        <div className="answer">
                            <p className="faq-ans">{faq.answer}</p>
                        </div>
                    )}
                </div>
            ))
        ));
    };

    return (
        <div className="faq-Row">
            <div className="leftImage">
                <img src="images/FAQ/FAQ-Image.png" alt="" />
            </div>
            <div className="accordianSection">
                <h2 className="sectionHeading">FAQ</h2>
                <div className="faq-search">
                    <SearchInput faqData={faqData} setfaqData={setSearchResults} />
                </div>
                <div className="faqTabPanel">
                    <div className="tabButton-wrapper">
                        <button
                            className={
                                displaySkill === "GeneralFAQ" ? "tabActive" : "tabInactive"
                            }
                            onClick={() => setDisplaySkill("GeneralFAQ")}
                        >
                            General FAQs
                        </button>
                        <button
                            className={
                                displaySkill === "Nominations" ? "tabActive" : "tabInactive"
                            }
                            onClick={() => setDisplaySkill("Nominations")}
                        >
                            Nominations
                        </button>
                        <button
                            className={
                                displaySkill === "Curriculum" ? "tabActive" : "tabInactive"
                            }
                            onClick={() => setDisplaySkill("Curriculum")}
                        >
                            Curriculum
                        </button>
                        <button
                            className={
                                displaySkill === "smeSession" ? "tabActive" : "tabInactive"
                            }
                            onClick={() => setDisplaySkill("smeSession")}
                        >
                            SME Session
                        </button>
                        <button
                            className={
                                displaySkill === "Certification" ? "tabActive" : "tabInactive"
                            }
                            onClick={() => setDisplaySkill("Certification")}
                        >
                            Certification
                        </button>
                    </div>
                    <div className="contentOuterBox">
                        {currentItems.length === 0 ? (
                            <p>No records found.</p>
                        ) : (
                            <div className="tabContentWrap">
                                <div className="faq-container-question">
                                    {displaySkill === "GeneralFAQ" &&
                                        renderFAQs("GeneralFAQs")}
                                    {displaySkill === "Nominations" &&
                                        renderFAQs("Nominations")}
                                    {displaySkill === "Curriculum" &&
                                        renderFAQs("Curriculum")}
                                    {displaySkill === "smeSession" &&
                                        renderFAQs("smeSession")}
                                    {displaySkill === "Certification" &&
                                        renderFAQs("Certification")}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {/* Pagination can be added here if needed */}
            </div>
        </div>
    );
}

export default FAQAccordion;
